import { render, staticRenderFns } from "./VippsStrategy.vue?vue&type=template&id=fa1462dc"
import script from "./VippsStrategy.vue?vue&type=script&lang=ts"
export * from "./VippsStrategy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports